import { jsx as _jsx } from "react/jsx-runtime";
import AnswersAddress from './AnswersAddress';
import AnswersEmail from './AnswersEmail';
import AnswersMultipleChoice from './AnswersMultipleChoice';
import AnswersName from './AnswersName';
import AnswersNPS from './AnswersNPS';
import AnswersSingleChoice from './AnswersSingleChoice';
import AnswersTelephone from './AnswersTelephone';
import AnswersTextbox from './AnswersTextbox';
/**
 * Shows answers for various questions.
 */
const Answers = ({
  question
}) => {
  switch (question.type) {
    case 'multiple_selection':
      {
        const {
          answerChoices
        } = question;
        return _jsx(AnswersMultipleChoice, {
          answerChoices: answerChoices
        });
      }
    case 'single_choice':
      {
        const {
          answerChoices,
          title
        } = question;
        return _jsx(AnswersSingleChoice, {
          answerChoices: answerChoices,
          title: title
        });
      }
    case 'address':
      return _jsx(AnswersAddress, {});
    case 'email':
      return _jsx(AnswersEmail, {});
    case 'name':
      return _jsx(AnswersName, {});
    case 'nps':
      return _jsx(AnswersNPS, {});
    case 'telephone':
      return _jsx(AnswersTelephone, {});
    case 'open_ended':
      return _jsx(AnswersTextbox, {});
  }
  // @TODO: log error for this
  return null;
};
export default Answers;